module.exports = __webpack_public_path__ + "img/360.e1d76b96.svg";